import {StepItemStatus} from 'ui-library/StepNav';

import {FileListingGraphQL} from '../../../graphql-fragments/files/__generated/FileListingGraphQL';

export enum StepKey {
  ATTACH = 'ATTACH',
  PROCESS = 'PROCESS',
}

export interface ImportConnectionFilesModalState {
  statusByStep: {[key in StepKey]: StepItemStatus};
  currentStepKey: StepKey;
  selectedRowIndices: Set<number>;
  selectedProcessConnectionFiles: Array<FileListingGraphQL>;
  isImporting: boolean;
  connectionFiles: Array<FileListingGraphQL>;
}

export const INITIAL_STATE: ImportConnectionFilesModalState = {
  statusByStep: {
    [StepKey.ATTACH]: StepItemStatus.UNVISITED,
    [StepKey.PROCESS]: StepItemStatus.UNVISITED,
  },
  currentStepKey: StepKey.PROCESS,
  selectedRowIndices: new Set(),
  selectedProcessConnectionFiles: [],
  isImporting: false,
  connectionFiles: [],
};
